import { useDeviceType } from '@cian/ui-kit';
import styles from './Link.css';
import { FC, DetailedHTMLProps, AnchorHTMLAttributes } from 'react';

interface ILinkProps extends DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  dataName?: string;
}

export const Link: FC<ILinkProps> = ({ children, dataName, ...rest }) => {
  const device = useDeviceType();

  const target = device === 'desktop' ? '_blank' : undefined;

  return (
    <a target={target} {...rest} rel="noopener noreferrer" className={styles['link']} data-name={dataName}>
      {children}
    </a>
  );
};
